'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record } from 'immutable';
import { fromMillis } from '../ad-management/ScheduleRecord';
import { fromNetwork } from '../ad-management/BudgetRecord'; // LinkedIn calls this a "campaign"

export default class LinkedInAdGroupRecord extends Record({
  accountId: null,
  campaignId: null,
  id: null,
  name: null,
  network: null,
  status: null,
  type: null,
  objective: null,
  previousState: null,
  keyResultSource: null,
  schedule: null,
  dailyBudget: null,
  totalBudget: null,
  offsiteDeliveryEnabled: null
}) {
  constructor(_ref) {
    let {
      endTime,
      startTime,
      dailyBudget,
      totalBudget
    } = _ref,
        data = _objectWithoutPropertiesLoose(_ref, ["endTime", "startTime", "dailyBudget", "totalBudget"]);

    super(Object.assign({}, data, {
      dailyBudget: dailyBudget && fromNetwork(dailyBudget),
      totalBudget: totalBudget && fromNetwork(totalBudget),
      schedule: fromMillis(startTime, endTime)
    }));
  }

}